<template>
  <div class="homeview">
    <FormAbonnementView />
  </div>
</template>

<script>
import FormAbonnementView from './FormAbonnementView.vue'


export default {
  name: 'HomeView',
  components: {
    FormAbonnementView,
  },
}

</script>